import React, { useState, useEffect } from 'react'
import { CommonHeader, EmptyListPage, ErrorSuccessModal, TableLoader } from '../../../components/commons'
import { connect } from 'react-redux'
import { getRecurringJobsDetailsAction, resetError, resetFetching, resetRecurringJobsDetailsList, resetStatusCode, resetSuccess, resetTotalRecurringJobsListCount } from '../../../redux/jobs'
import { resetSession } from '../../../redux/auth'
import { RootState } from '../../../redux/rootReducers'
import { SearchIcon } from '../../../components/Icon'
import { EmptyJobsPage } from '../../../assets/images'
import RecurringJobsSettingTable from '../../../components/Jobs/RecurringJobsSetting/RecurringJobsSettingTable/RecurringJobsSettingTable'
import useDebounce from '../../../customHooks/useDebounce'
import InfiniteLoader from '../../../components/commons/InfiniteLoader/InfiniteLoader'
import ScrollToTop from '../../../components/commons/ScrollToTop'
import RecurringJobSorting from './RecurringJobSorting'
import { GetRecurringJobsSettingPayload } from '../../../commonTypes/jobsType'
type AppProps = {
    history: any;
    token: string | null;
    error: string | null | undefined;
    success: number | null;
    statusCode: number | null;
    fetching: boolean;
    clientFetching: boolean;
    totalCount: number | null;
    recurringJobsList: any;
    dispatchGetRecurringJobsDetailsAction: (data: GetRecurringJobsSettingPayload) => void;
    dispatchResetSession: () => void;
    dispatchResetSuccess: () => void;
    dispatchResetStatusCode: () => void;
    dispatchResetError: () => void;
    dispatchResetFetching: () => void;
    dispatchResetRecurringJobsDetailsList: () => void;
    dispatchResetTotalRecurringJobsListCount: () => void;
}
const RecurringJobsSetting = ({
    history,
    token,
    statusCode,
    success,
    fetching,
    error,
    totalCount,
    clientFetching,
    recurringJobsList,
    dispatchResetSession,
    dispatchResetSuccess,
    dispatchResetStatusCode,
    dispatchResetError,
    dispatchGetRecurringJobsDetailsAction,
    dispatchResetRecurringJobsDetailsList,
    dispatchResetFetching,
    dispatchResetTotalRecurringJobsListCount
}: AppProps) => {
    const persistSearchTerm = history?.location?.state?.searchTerm
    const [offset, setOffset] = useState<number>(0);
    const [searchTerm, setSearchTerm] = useState<string>(persistSearchTerm)
    const [limit, setLimit] = useState<number>(20);
    const [finalRecurringJobsSettingList, setFinalRecurringJobsSettingList] = useState<any[]>([])
    const [clearSearch, setClearSearch] = useState<boolean>(false);
    const [jobType, setJobType] = useState({ name: "", value: "" })
    const [sortByCc, setSortByCc] = useState({ name: "", value: "" })
    const [data, setData] = useState<any>([])

    const persistJobType= history?.location?.state?.jobType;
    const persistSortByCC = history?.location?.state?.sortByCc;



    useEffect(() => {
        window.scroll({
            top: 0,
            left: 0
        })
        dispatchResetError()
        dispatchResetSuccess()
        dispatchResetStatusCode()
        dispatchResetTotalRecurringJobsListCount()
        dispatchResetRecurringJobsDetailsList()
        if(persistJobType || persistSortByCC){
            setJobType(persistJobType)
            setSortByCc(persistSortByCC)
        }
        setData([
            { name: "", value: "" },
            { name: "Job Type - A to Z", value: "asc" },
            { name: "Job Type - Z to A", value: "desc" },
            { name: "Code - Ascending", value: "asc" },
            { name: "Code - Descending", value: "desc" }
        ])
    }, [])

    

    useEffect(() => {
        if (token) {
            const finalData = {
                token,
                offset,
                limit,
                searchTerm,
                sortByClientCode: sortByCc?.value  ? sortByCc?.value : persistSortByCC?.value,
                sortByJobType:jobType?.value ? jobType?.value : persistJobType?.value
            }
            if (totalCount) {
                if (totalCount > offset) {
                    dispatchGetRecurringJobsDetailsAction(finalData)
                }
            } else {
                dispatchGetRecurringJobsDetailsAction(finalData)
            }
        }
    }, [offset])

    useEffect(() => {
        if (recurringJobsList?.length === 0) {
            setFinalRecurringJobsSettingList(recurringJobsList);
        }
        else if (offset > 0 && recurringJobsList?.length > 0 && finalRecurringJobsSettingList?.length>0) {
            setFinalRecurringJobsSettingList((prev: any) => [...prev, ...recurringJobsList]);
        }
        else {
            setFinalRecurringJobsSettingList(recurringJobsList);
        }
    }, [recurringJobsList])

    useEffect(() => {
        dispatchResetError()
        dispatchResetSuccess()
        dispatchResetStatusCode()
        dispatchResetTotalRecurringJobsListCount()
        dispatchResetRecurringJobsDetailsList()
        setFinalRecurringJobsSettingList([])
        if (token && ((!!sortByCc?.name) || (!!jobType?.name))) {
            const finalData = {
                token,
                offset,
                limit,
                searchTerm,
                sortByClientCode: sortByCc?.value,
                sortByJobType:jobType?.value
            }
            dispatchGetRecurringJobsDetailsAction(finalData)
        }
    }, [jobType, sortByCc])

    useEffect(() => {
        window.addEventListener('scroll', onScroll)
        return () => window.removeEventListener('scroll', onScroll)
    }, [recurringJobsList])

    const onScroll = () => {
        if (!fetching && totalCount) {
            const scrollTop = document.documentElement.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight;
            const clientHeight = document.documentElement.clientHeight;
            if (offset < totalCount && Math.ceil(75 / 100 * scrollHeight) <= scrollTop + clientHeight) {
                setOffset(offset + limit)
            }
        }
    }

    const handleSort = (data: any) => {
        setOffset(0)
        dispatchResetError()
        dispatchResetSuccess()
        dispatchResetStatusCode()
        dispatchResetTotalRecurringJobsListCount()
        dispatchResetRecurringJobsDetailsList()
        if (data?.name === "Code - Ascending" || data?.name === "Code - Descending") {
            setSortByCc({...data})
            setJobType({ name: "", value: "" })
        }
        else {
            setJobType({...data})
            setSortByCc({ name: "", value: "" })
        }
    }

    useDebounce(() => {
        if (searchTerm) {
            fetchNewData()
        }
        else if(clearSearch) {
            const finalData = {
                token,
                offset,
                limit,
                searchTerm,
                sortByClientCode: sortByCc?.value  ? sortByCc?.value : persistSortByCC?.value,
                sortByJobType:jobType?.value ? jobType?.value : persistJobType?.value
            }
            dispatchGetRecurringJobsDetailsAction(finalData)
        }
    }, 500, [searchTerm])

    const fetchNewData = () => {
        if (searchTerm) {
            setClearSearch(true)
            const finalData = {
                token,
                offset,
                limit,
                searchTerm,
                sortByClientCode: sortByCc?.value  ? sortByCc?.value : persistSortByCC?.value,
                sortByJobType:jobType?.value ? jobType?.value : persistJobType?.value
            }
            dispatchGetRecurringJobsDetailsAction(finalData)
        }
    }
   //commented for future use
    // useEffect(()=>{
    //     if(persistJobType?.value || persistSortByCc?.value){
    //         setOffset(0)
    //         dispatchResetError()
    //         dispatchResetSuccess()
    //         dispatchResetStatusCode()
    //         dispatchResetTotalRecurringJobsListCount()
    //         dispatchResetRecurringJobsDetailsList()
    //         setFinalRecurringJobsSettingList([])
    //         setSortByCc({...persistSortByCc})
    //         setJobType({...persistJobType})
    //     }
    //     },[persistJobType,persistSortByCc])

    const handleSearch = (e: any) => {
        setOffset(0)
        setSearchTerm(e.target.value);
    };

    const handleErrorModal = () => {
        if (success === 0) {
            if (statusCode === 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message="Session Expired. Please Login Again!"
                        buttonText="Logout"
                        onPress={() => dispatchResetSession()}
                        statusCode={statusCode}
                    />
                )
            } else if ((!!error && statusCode !== 401)) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message={error}
                        buttonText="OK"
                        onPress={() => {
                            dispatchResetError()
                            dispatchResetSuccess()
                            dispatchResetTotalRecurringJobsListCount()
                            dispatchResetRecurringJobsDetailsList()
                        }}
                    />
                )
            }
        }

        return false;
    }

    const handleEditRecurringJobSetting = (data: any) => {
        history.push({
            pathname: `/jobs/recurring-jobs/edit/${data?.clientCode}`,
            state: { companyName: data?.companyName, clientCode: data?.clientCode ,jobType,sortByCc , searchTerm }
        })
    }

    return (
        <div className="row">
            <div className="col-md-4 mb-3">
                <CommonHeader title="Recurring Job Setting" />
            </div>

            <div className="col-md-12">
                <div className='jobs-card'>
                    <div className="header">

                        <div className="left-header">
                            <div className="heading"> Recurring Job Setting List</div>
                            <div className="sub-heading">{`Total ${totalCount ? totalCount : 0} entries found`}</div>
                        </div>
                        <div className='right-header'>
                            <div className="col-md-6 position-relative" style={{marginRight:"-5px"}}>
                                <span style={{ position: "absolute", top: "8px", left: "25px" }}>
                                    <SearchIcon />
                                </span>
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Search"
                                    onChange={(e: any) => handleSearch(e)}
                                    style={{ paddingLeft: "35px" }}
                                    value={searchTerm}
                                />
                            </div>

                            <div className='mr-2'>
                                <RecurringJobSorting
                                    data={data}
                                    handleChange={handleSort}
                                    selectedData={jobType?.value ? jobType : (sortByCc?.value ? sortByCc : { name: "Recently Added/Modified First", value: "" })}
                                    history={history}
                                />
                            </div>
                            {<button onClick={() => {
                                history.push("/jobs/recurring-jobs/add")
                            }
                            } className="btn btn-primary">
                                + New Job Setting
                            </button>}
                        </div>

                    </div>

                    <div>
                        {(fetching && offset === 0) ? <TableLoader Rows={10} ColumnPerRow={7} />
                            : recurringJobsList?.length > 0 ? (
                                <RecurringJobsSettingTable
                                    recurringJobsList={finalRecurringJobsSettingList}
                                    handleEditRecurringJobSetting={handleEditRecurringJobSetting}
                                />
                            ) :
                                (<div className='mt-5 p-4'>
                                    <EmptyListPage
                                        title='No Recurring Job Setting Found!'
                                        image={EmptyJobsPage}
                                        imageWidth="30%"
                                        showLinkButton={false}
                                        showAddButton={false}
                                    />
                                </div>)
                        }
                    </div>
                    {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
                    {<div style={{ display: fetching ? "none" : "inline" }}><ScrollToTop /></div>}
                </div>
            </div>
            {handleErrorModal()}

        </div>
    )
}

const mapStateToProps = ((state: RootState) => ({
    clientDirectoryList: state.clientDirectory.clientDirectoryList,
    token: state.auth.token,
    totalCount: state.jobs.totalRecurringJobsListCount,
    clientFetching: state.clientDirectory.fetching,
    success: state.jobs.success,
    statusCode: state.jobs.statusCode,
    error: state.jobs.error,
    fetching: state.jobs.fetching,
    recurringJobsList: state?.jobs?.singleRecurringJobsDetails?.job_details
}))

const mapDispatchToProps = ((dispatch: any) => ({
    dispatchGetRecurringJobsDetailsAction: (data: GetRecurringJobsSettingPayload) => dispatch(getRecurringJobsDetailsAction(data)),
    dispatchResetSession: () => dispatch(resetSession()),
    dispatchResetSuccess: () => dispatch(resetSuccess()),
    dispatchResetStatusCode: () => dispatch(resetStatusCode()),
    dispatchResetFetching: () => dispatch(resetFetching()),
    dispatchResetTotalRecurringJobsListCount: () => dispatch(resetTotalRecurringJobsListCount()),
    dispatchResetRecurringJobsDetailsList: () => dispatch(resetRecurringJobsDetailsList()),
    dispatchResetError: () => dispatch(resetError()),
}))

export default connect(mapStateToProps, mapDispatchToProps)(RecurringJobsSetting)